<div class="sales-form-container">
	<span #salesFormComponent></span>
	<form [formGroup]="salesFormGroup" #formSalesDirective="ngForm" (submit)="submitSalesForm(formSalesDirective, $event)">
		<div class="row mx-1 mt-2">
			<div class="col">
				<mat-form-field class="field-with-insert-button w-100 pb-2">
					<mat-label>{{ 'SALES.TRUSTEE' | translate }}</mat-label>
					<mat-chip-grid #trusteeGrid aria-label="Trustee selection">
						@for (trustee of selectedTrustees; track $index) {
						<mat-chip-row (removed)="itemAction('REMOVE', 'TRUSTEE', trustee)">
							{{ utils.getParameterByLanguageScript(trustee, 'name', true) }}
							<button matChipRemove [attr.aria-label]="'remove ' + trustee.id">
								<mat-icon>cancel</mat-icon>
							</button>
						</mat-chip-row>
						}
					</mat-chip-grid>
					<input type="text" matInput #trusteeInput formControlName="trustees" [matChipInputFor]="trusteeGrid" [matAutocomplete]="trusteeAutocomplete" />
					<mat-autocomplete #trusteeAutocomplete="matAutocomplete" [displayWith]="displayFnBusinessEntity.bind(this)" (optionSelected)="itemAction('SELECT', 'TRUSTEE', $event)">
						@for (businessEntity of filteredBusinessEntities; track $index) {
						<mat-option [value]="businessEntity">{{ utils.getParameterByLanguageScript(businessEntity, 'name', true) }}</mat-option>
						}
					</mat-autocomplete>
					<button
						matSuffix
						mat-button
            type="button"
						color="primary"
						aria-label="Add business entity"
						matTooltip="{{ 'BUTTON.CREATE' | translate }} {{ 'BUSINESS_ENTITY.TITLE' | translate }}"
						matTooltipPosition="below"
						(click)="itemAction('CREATE', 'TRUSTEE', salesFormGroup.controls['trustees'].value)">
						<mat-icon class="m-0">add</mat-icon>
					</button>
					@if(selectedTrustees.length === 0 && selectedDebtors.length === 0) {
					<div class="font hint">*{{ 'NOTIFICATIONS.REQUIRED_VALUE' | translate }}</div>
					}
				</mat-form-field>

				<mat-form-field class="field-with-insert-button w-100 pb-2">
					<mat-label>{{ 'SALES.DEBTOR' | translate }}</mat-label>
					<mat-chip-grid #debtorGrid aria-label="Debtor selection">
						@for (debtor of selectedDebtors; track $index) {
						<mat-chip-row (removed)="itemAction('REMOVE', 'DEBTOR', debtor)">
							{{ utils.getParameterByLanguageScript(debtor, 'name', true) }}
							<button matChipRemove [attr.aria-label]="'remove ' + debtor.id">
								<mat-icon>cancel</mat-icon>
							</button>
						</mat-chip-row>
						}
					</mat-chip-grid>
					<input type="text" matInput #debtorInput formControlName="debtors" [matChipInputFor]="debtorGrid" [matAutocomplete]="debtorAutocomplete" />
					<mat-autocomplete #debtorAutocomplete="matAutocomplete" [displayWith]="displayFnBusinessEntity.bind(this)" (optionSelected)="itemAction('SELECT', 'DEBTOR', $event)">
						@for (businessEntity of filteredBusinessEntities; track $index) {
						<mat-option [value]="businessEntity">{{ utils.getParameterByLanguageScript(businessEntity, 'name', true) }}</mat-option>
						}
					</mat-autocomplete>
					<button
						matSuffix
						mat-button
            type="button"
						color="primary"
						aria-label="Add business entity"
						matTooltip="{{ 'BUTTON.CREATE' | translate }} {{ 'BUSINESS_ENTITY.TITLE' | translate }}"
						matTooltipPosition="below"
						(click)="itemAction('CREATE', 'DEBTOR', salesFormGroup.controls['debtors'].value)">
						<mat-icon class="m-0">add</mat-icon>
					</button>
					@if(selectedTrustees.length === 0 && selectedDebtors.length === 0) {
					<div class="font hint">*{{ 'NOTIFICATIONS.REQUIRED_VALUE' | translate }}</div>
					}
				</mat-form-field>

				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SALES.PLACE_OF_SALE' | translate }}</mat-label>
          <mat-chip-grid #placesOfSaleGrid aria-label="Place selection">
            @for (place of selectedPlacesOfSale; track $index) {
              <mat-chip-row (removed)="itemAction('REMOVE', 'PLACE_OF_SALE', place)">
                {{ place }}
                <button matChipRemove [attr.aria-label]="'remove_' + place">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
          </mat-chip-grid>
					<input
						type="text"
						matInput
            #placesOfSaleInput
						formControlName="placesOfSale"
						[matAutocomplete]="placeOfSaleAutocomplete"
            [matChipInputFor]="placesOfSaleGrid"
            (matChipInputTokenEnd)="itemAction('ADD', 'PLACE_OF_SALE', $event)"
						placeholder="{{ 'BUTTON.SEARCH' | translate }}"
						(click)="filteredLocations = []" />
					<mat-autocomplete #placeOfSaleAutocomplete="matAutocomplete" (optionSelected)="itemAction('SELECT', 'PLACE_OF_SALE', $event)">
						@for (location of filteredLocations; track $index) {
						<mat-option [value]="location">{{ location }}</mat-option>
						}
					</mat-autocomplete>
				</mat-form-field>

				<mat-form-field class="w-100 pb-3">
					<mat-label>{{ 'SALES.LOCATION' | translate }}</mat-label>
          <mat-chip-grid #locationsGrid aria-label="Location selection">
            @for (location of selectedLocations; track $index) {
              <mat-chip-row (removed)="itemAction('REMOVE', 'LOCATION', location)">
                {{ location }}
                <button matChipRemove [attr.aria-label]="'remove_' + location">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
          </mat-chip-grid>
					<input
						type="text"
						matInput
            #locationsInput
						formControlName="locations"
						[matAutocomplete]="locationAutocomplete"
            [matChipInputFor]="locationsGrid"
            (matChipInputTokenEnd)="itemAction('ADD', 'LOCATION', $event)"
						placeholder="{{ 'BUTTON.SEARCH' | translate }}"
						(click)="filteredLocations = []" />
					<mat-autocomplete #locationAutocomplete="matAutocomplete" (optionSelected)="itemAction('SELECT', 'LOCATION', $event)">
						@for (location of filteredLocations; track $index) {
						<mat-option [value]="location">{{ location }}</mat-option>
						}
					</mat-autocomplete>
          @if(selectedLocations.length === 0) {
            <div class="font hint">*{{ 'NOTIFICATIONS.REQUIRED_VALUE' | translate }}</div>
            }
				</mat-form-field>

        <mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SALES.URL' | translate }}</mat-label>
					<input type="text" matInput formControlName="publicationUrl" />
				</mat-form-field>

				<mat-form-field class="field-with-insert-button w-100 pb-2">
					<mat-label>{{ 'CONTRACT_NOTICES.PDF_FILE' | translate }} / {{ 'SALES.IMAGE' | translate }}</mat-label>
					<input type="text" matInput formControlName="fileUrl" readonly />
					<button
						type="button"
						matSuffix
						mat-flat-button
						color="primary"
						aria-label="Upload image"
						matTooltip="{{ 'BUTTON.UPLOAD' | translate }}"
						matTooltipPosition="below"
						(click)="fileInput.click()">
						<mat-icon class="m-0">upload</mat-icon>
					</button>
					<input hidden id="file" type="file" #fileInput [accept]="getAcceptedFileFormats()" (change)="selectFilesForUpload($event)" />
				</mat-form-field>

				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SALES.TYPE' | translate }}
            <!-- workaround for material-chrome bug -->
							<select id="type" style="display: none"></select>
          </mat-label>
					<mat-select formControlName="type">
						@for (type of types; track $index) {
						<mat-option [value]="type">{{ 'SALES.TYPES.' + type | translate }}</mat-option>
						}
					</mat-select>
				</mat-form-field>

				<div class="d-flex flex-wrap pb-2">
					<mat-form-field class="w-50">
						<mat-label>{{ 'SALES.PUBLISHED_DATE' | translate }}</mat-label>
						<input matInput id="published-date" [matDatepicker]="publishedDatePicker" formControlName="publicationDate" />
						<mat-datepicker-toggle matIconSuffix [for]="publishedDatePicker"></mat-datepicker-toggle>
						<mat-datepicker #publishedDatePicker></mat-datepicker>
					</mat-form-field>

					<mat-form-field class="w-50 ps-1">
						<mat-label>{{ 'SALES.SALE_DATE' | translate }}</mat-label>
						<input matInput id="sale-date" [matDatepicker]="saleDatePicker" formControlName="saleDate" />
						<mat-datepicker-toggle matIconSuffix [for]="saleDatePicker"></mat-datepicker-toggle>
						<mat-datepicker #saleDatePicker></mat-datepicker>
					</mat-form-field>
				</div>

        <mat-checkbox class="w-100 mb-2" color="primary" formControlName="eSale">{{ 'SALES.E_SALE' | translate }}</mat-checkbox>

			</div>
			<div class="col ps-0 pt-2">
				<mat-form-field class="w-100 h-100">
					<mat-label>{{ 'SALES.TEXT' | translate }}</mat-label>
					<textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="6" formControlName="text"></textarea>
				</mat-form-field>
			</div>
		</div>

		<div class="d-flex mt-2 mx-3">
			<button
				type="button"
				mat-raised-button
				color="primary"
				class="me-1"
				aria-label="Reset form button"
				matTooltip="{{ 'ASSORTED.RESET_FORM' | translate }}"
				matTooltipPosition="below"
				[disabled]="apiLoading.sales"
				(click)="resetForm(formSalesDirective)">
				<mat-icon class="m-0">restart_alt</mat-icon>
			</button>

			<button
				type="submit"
				mat-raised-button
				color="primary"
				class="w-100"
				aria-label="Submit form button"
				[disabled]="!checkFormValidity() || !salesFormGroup.valid || apiLoading.sales">
				@if(apiLoading.sales) {
				<mat-spinner diameter="20"></mat-spinner>
				} @else {
				<span>{{ 'BUTTON.' + mode | translate }} {{ 'SALES.SALE' | translate }}</span>
				}
			</button>
		</div>
	</form>
</div>
